module.exports = __webpack_public_path__ + "media/icons/menu-fbfd7497.png";